import { Drawer, Stack } from "@mui/material";
import PaymentCreate from "./PaymentCreate";

const PaymentCreateDrawer = ({ open, onClose, refetch, studentId }: any) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "550px",
          maxWidth: "80vw",
          backgroundColor: "#232323",
          boxShadow: "none",
        },
      }}
    >
      <Stack
        p={2}
        sx={{ overflowY: "auto", backgroundColor: "secondary.main" }}
      >
        <PaymentCreate
          onClose={onClose}
          refetch={refetch}
          studentId={studentId}
        />
      </Stack>
    </Drawer>
  );
};

export default PaymentCreateDrawer;
